import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import { FiberManualRecord } from "@material-ui/icons";
import React, { Fragment, useState } from "react";
import Wallet from "src/icons/Wallet";

import ConnectWalletDialog from "../ConnectWalletDialog";

const useStyles = makeStyles((theme) => ({
  button: {
    border: 0,
    textTransform: "capitalize",
    padding: theme.spacing(1.2, 1),
    minWidth: "163px",
    background: "linear-gradient(100.42deg, #2C85EE 16.07%, #4FB5FF 79.2%)",
  },
  fiberIcon: {
    fontSize: 10,
    verticalAlign: "middle",
    marginRight: 2,
    color: "#C4C4C4",
  },
}));

function ConnectWalletButton() {
  const [isOpenConnectModal, setIsOpenConnectModal] = useState(false);
  const classes = useStyles();

  function hdClickConnectWallet(ev) {
    setIsOpenConnectModal(true);
  }

  return (
    <Fragment>
      <Button size="small" className={classes.button} variant="outlined" onClick={hdClickConnectWallet}>
        <Box display="flex" alignItems="center">
          <Wallet size={22} />
          <Box pl={1.5} display="flex" alignItems="center">
            <span style={{ fontSize: 15, lineHeight: 0 }}>Connect Wallet</span>
          </Box>
        </Box>
      </Button>
      {isOpenConnectModal && <ConnectWalletDialog hdClosePopup={() => setIsOpenConnectModal(false)} />}
    </Fragment>
  );
}

export default ConnectWalletButton;
